function drawDot(ctx, x, y, r, color) {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
  ctx.fillStyle = color;
  ctx.fill();
}

function loadLogo() {
  return new Promise((res) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = "/logo.png";
  });
}

export async function drawMovimentiImage(match, movements) {
  const W = 760;
  const rowH = 58;
  const headerH = 210;
  const tableHeadH = 46;
  const H = headerH + tableHeadH + movements.length * rowH + 60;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  const GOLD = "#E3BC55";

  ctx.fillStyle = "#000";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 3;
  ctx.strokeRect(10, 10, W - 20, H - 20);

  ctx.textAlign = "center";
  const logo = await loadLogo();
  if (logo) {
    const lw = 300;
    const lh = lw * (logo.height / logo.width);
    ctx.drawImage(logo, (W - lw) / 2, 55 - lh / 2 - 8, lw, lh);
  } else {
    ctx.fillStyle = GOLD;
    ctx.font = "bold 20px monospace";
    ctx.fillText("Z E R O   S I G N A L S", W / 2, 55);
  }
  ctx.fillStyle = "#94A3B8";
  ctx.font = "bold 15px sans-serif";
  ctx.fillText("CAMPIONATO SELEZIONATO", W / 2, 90);
  ctx.fillStyle = GOLD;
  ctx.font = "bold 26px sans-serif";
  ctx.fillText(match.league, W / 2, 120);
  ctx.fillStyle = "#fff";
  ctx.font = "bold 28px sans-serif";
  ctx.fillText(`${match.home_team}  vs  ${match.away_team}`, W / 2, 160);
  ctx.fillStyle = GOLD;
  ctx.font = "bold 22px sans-serif";
  ctx.fillText("MOVIMENTI CONSIGLIATI", W / 2, 198);

  const colX = [150, 330, 440, 550, 660];
  ctx.font = "bold 19px sans-serif";
  ctx.fillStyle = GOLD;
  ctx.textAlign = "left";
  ctx.fillText("ESITO", 60, headerH + 30);
  ctx.textAlign = "center";
  ["1", "2", "3", "Star"].forEach((h, i) => ctx.fillText(h, colX[i + 1], headerH + 30));
  ctx.strokeStyle = "rgba(227,188,85,0.35)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(40, headerH + tableHeadH - 4);
  ctx.lineTo(W - 40, headerH + tableHeadH - 4);
  ctx.stroke();

  movements.forEach((m, i) => {
    const y = headerH + tableHeadH + i * rowH + rowH / 2;
    ctx.fillStyle = "#fff";
    ctx.font = "bold 20px sans-serif";
    ctx.textAlign = "left";
    ctx.fillText(m.market, 60, y + 7);
    for (let d = 1; d <= 3; d++) {
      drawDot(ctx, colX[d], y, 16, m.intensity >= d ? "#10B981" : "#D9D9D9");
    }
    drawDot(ctx, colX[4], y, 16, m.star ? "#E3BC55" : "#D9D9D9");
  });

  const code = (localStorage.getItem("zs_code") || "").toUpperCase();
  if (code) {
    // watermark diagonale ripetuto (anti-leak)
    ctx.save();
    ctx.globalAlpha = 0.20;
    ctx.fillStyle = GOLD;
    ctx.font = "bold 22px monospace";
    ctx.textAlign = "center";
    ctx.translate(W / 2, H / 2);
    ctx.rotate(-Math.PI / 7);
    const tile = `ZERO SIGNALS · ${code}`;
    const stepX = 320;
    const stepY = 90;
    for (let ry = -H; ry < H; ry += stepY) {
      for (let rx = -W; rx < W; rx += stepX) {
        ctx.fillText(tile, rx, ry);
      }
    }
    ctx.restore();
    // footer identificativo
    ctx.fillStyle = "rgba(227,188,85,0.75)";
    ctx.font = "bold 13px monospace";
    ctx.textAlign = "center";
    ctx.fillText(`ID licenza: ${code} · uso personale · vietata la ridistribuzione`, W / 2, H - 26);
  }

  return canvas;
}

export function buildShareText(match, movements) {
  const lines = movements
    .filter((m) => m.intensity > 0 || m.star)
    .map((m) => `${m.star ? "⭐ " : "🟢 "}${m.market} — ${m.prob_pct}%`);
  return `ZERO SIGNALS · ${match.league}\n${match.home_team} vs ${match.away_team}\n\nMovimenti consigliati:\n${lines.join("\n") || "Nessun segnale forte"}`;
}

export async function shareMovimentiImage(match, movements) {
  const canvas = await drawMovimentiImage(match, movements);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const fileName = `zero-signals-${match.home_team}-${match.away_team}.png`.replace(/\s+/g, "-").toLowerCase();
  const file = new File([blob], fileName, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: "Zero Signals", text: buildShareText(match, movements) });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
  return "downloaded";
}
